<div class="config-email">
    <div [class.input-wrapper]="altStyling">
        <mat-form-field>
            <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
            <mat-label *ngIf="!placeholder" i18n="@@configurator.driver.label-email">E-mail address</mat-label>
            <input
                matInput
                type="email"
                name="email"
                [id]="id"
                [class.text-input]="altStyling"
                [formControl]="componentFormControl"
            />

            <mat-error i18n="@@configurator.driver.validation-error-email">Invalid e-mail address</mat-error>
        </mat-form-field>
    </div>
</div>
